import { createContext } from 'react'
import { FormattedPropertyData } from '../models/property-details-page/property-details-model'

export type PropertyDetailsContextType = {
    propertyDetails: FormattedPropertyData | null
    isComboListing: boolean
}

export const PropertyDetailsContext = createContext<PropertyDetailsContextType | undefined>(undefined)
